export default class QueryTableStatus
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryTableStatus";

	static Open = "Open";
	static Lock = "Lock";
	static Hide = "Hide";
		
	static OPENLABEL = "Open";
	static LOCKLABEL = "Lock";
	static HIDELABEL = "Hide";
		
	static valueOf(value)
	{
		if(value == QueryTableStatus.OPENLABEL || value == "")
			return QueryTableStatus.Open;
		else if(value == QueryTableStatus.LOCKLABEL)
			return QueryTableStatus.Lock;
		else if(value == QueryTableStatus.HIDELABEL)
			return QueryTableStatus.Hide;
		
		throw new Error("错误的枚举类型");
		
	}
	
	static getLabel(value)
	{
		if(value == QueryTableStatus.Open)
			return QueryTableStatus.OPENLABEL;
		else if(value == QueryTableStatus.Lock)
			return QueryTableStatus.LOCKLABEL;
		else if(value == QueryTableStatus.Hide)
			return QueryTableStatus.HIDELABEL;
		
		throw new Error("错误的枚举类型");
	}
}


// WEBPACK FOOTER //
// ./src/query/remote/QueryTableStatus.js